module.exports = __webpack_public_path__ + "static/media/46-iveco-mercedes.7de68c51.jpg";